import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background: rgba(180, 188, 200, 0.05);
  border-radius: 12px;
  padding: 24px;
  transition: transform 0.3s ease;
  border: 1px solid rgba(180, 188, 200, 0.1);

  &:hover {
    transform: translateY(-5px);
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`;

const AppIcon = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 14px;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid rgba(180, 188, 200, 0.2);
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ProjectTitle = styled.h3`
  font-family: 'DM Serif Display';
  font-size: 1.8rem;
  color: #B4BCC8;
`;

const DownloadsBadge = styled.span`
  align-self: flex-start;
  background: rgba(137, 139, 167, 0.25);
  border: 1px solid rgba(180, 188, 200, 0.25);
  padding: 3px 12px;
  border-radius: 16px;
  font-family: 'DM Serif Text';
  font-size: 0.85rem;
  color: #B4BCC8;
`;

const ProjectDescription = styled.p`
  font-family: 'DM Serif Text';
  font-size: 1rem;
  color: #B4BCC8;
  line-height: 1.6;
  margin-bottom: 24px;
`;

const TechStack = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 16px;
`;

const TechTag = styled.span`
  background: rgba(180, 188, 200, 0.1);
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'DM Serif Text';
  font-size: 0.9rem;
  color: #B4BCC8;
`;

const DownloadButton = styled.a`
  display: inline-block;
  margin-top: 24px;
  padding: 10px 20px;
  border-radius: 20px;
  background: rgba(180, 188, 200, 0.1);
  border: 1px solid rgba(180, 188, 200, 0.3);
  font-family: 'DM Serif Text';
  font-size: 1rem;
  color: #B4BCC8;
  text-decoration: none;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: rgba(180, 188, 200, 0.2);
    color: #898BA7;
  }
`;

const ProjectCard = ({ title, description, technologies, downloadUrl, iconUrl, downloads }) => {
  return (
    <CardContainer>
      <CardHeader>
        {iconUrl && <AppIcon src={iconUrl} alt={`${title} app icon`} />}
        <HeaderText>
          <ProjectTitle>{title}</ProjectTitle>
          {downloads && <DownloadsBadge>{downloads}</DownloadsBadge>}
        </HeaderText>
      </CardHeader>
      <ProjectDescription>{description}</ProjectDescription>
      <TechStack>
        {technologies.map((tech, index) => (
          <TechTag key={index}>{tech}</TechTag>
        ))}
      </TechStack>
      {downloadUrl && (
        <div>
          <DownloadButton
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download on the App Store
          </DownloadButton>
        </div>
      )}
    </CardContainer>
  );
};

export default ProjectCard;